import { defineStore, acceptHMRUpdate } from 'pinia'
import { SET_ERROR_DETAIL, UPD_ERROR_DETAIL, UPD_TOP_PANEL, UPD_HELP_POPUP, UPD_TOP_PANEL2, UPD_TOP_PANEL3, UPD_TOP_PANEL4, UPD_TOP_PANEL5 } from '@/constants'

interface ApplicationState {
  googleAnalytics: any
  isLoadComplete: boolean
  isLoadComplete2: boolean
  errorDetail: Array<string>
  shouldShowTopPanel: boolean
  shouldShowTopPanel2: boolean
  shouldShowTopPanel3: boolean
  shouldShowTopPanel4: boolean
  shouldShowTopPanel5: boolean
  shouldShowHelpPopup: boolean
}

export const useApplicationStore = defineStore({
  id: 'ApplicationStore',
  state: (): ApplicationState => ({
    googleAnalytics: null,
    isLoadComplete: false,
    isLoadComplete2: false,
    errorDetail: [],
    shouldShowTopPanel: true,
    shouldShowTopPanel2: false,
    shouldShowTopPanel3: false,
    shouldShowTopPanel4: false,
    shouldShowTopPanel5: false,
    shouldShowHelpPopup: false,
  }),
  getters: {
    /**
     * エラー内容を返却する
     */
    ErrorDetail: (state): Array<string> => state.errorDetail,
    /**
     * TOPパネル表示フラグを返却する
     */
    getShouldShowTopPanel: (state): boolean => state.shouldShowTopPanel,
    /**
     *  /**
     * TOPパネル表示フラグを返却する
     */
    getShouldShowTopPanel2: (state): boolean => state.shouldShowTopPanel2,
    /**
     *  *  /**
     * TOPパネル表示フラグを返却する
     */
    getShouldShowTopPanel3: (state): boolean => state.shouldShowTopPanel3,
    getShouldShowTopPanel4: (state): boolean => state.shouldShowTopPanel4,
    getShouldShowTopPanel5: (state): boolean => state.shouldShowTopPanel5,
    /**
     *
     * HELPポップアップ表示フラグを返却する
     */
    getShouldShowHelpPopup: (state): boolean => state.shouldShowHelpPopup,
  },
  actions: {
    /**
     * エラー内容の設定
     */
    [SET_ERROR_DETAIL](payload: unknown) {
      this.errorDetail.push(payload)
    },
    [UPD_ERROR_DETAIL]() {
      this.errorDetail = []
    },
    /**
     * TOPパネル表示フラグ反映
     */
    [UPD_TOP_PANEL](flag: boolean) {
      this.shouldShowTopPanel = flag
    },
    [UPD_TOP_PANEL2](flag: boolean) {
      this.shouldShowTopPanel2 = flag
    },
    [UPD_TOP_PANEL3](flag: boolean) {
      this.shouldShowTopPanel3 = flag
    },
    [UPD_TOP_PANEL4](flag: boolean) {
      this.shouldShowTopPanel4 = flag
    },
    [UPD_TOP_PANEL5](flag: boolean) {
      this.shouldShowTopPanel5 = flag
    },
    /**
     * HELP表示フラグ反映
     */
    [UPD_HELP_POPUP](flag: boolean) {
      this.shouldShowHelpPopup = flag
    },
  },
})

if (module.hot) {
  module.hot.accept(acceptHMRUpdate(useApplicationStore, module.hot))
}
